<template>
  <div id="music" class="music" @click="toggleMusic">
    <div class="note" :class="isPlay ? 'rotating on' : 'off'">
    </div>
    <audio :src="musicURL" id="myMusic" preload="preload" loop></audio>
  </div>
</template>

<script>
export default {
  name: "MusicPlayer",
  props: {},
  data() {
    return {
      musicURL: "https://jiandoukeji.com/h5/2021/keda/common/bgm.mp3",
      isPlay: true,
    };
  },
  mounted() {
    this.audioPlay();
  },
  methods: {
    toggleMusic() {
      if (this.isPlay) {
        this.audioPause();
      } else {
        this.audioPlay();
      }
      this.isPlay = !this.isPlay;
    },
    audioPlay() {
      let audio = document.getElementById("myMusic");
      audio.play();
      document.addEventListener(
        "WeixinJSBridgeReady",
        function () {
          audio.play();
        },
        false
      );
    },
    audioPause() {
      let audio = document.getElementById("myMusic");
      audio.pause();
      document.addEventListener(
        "WeixinJSBridgeReady",
        function () {
          audio.pause();
        },
        false
      );
    },
  },
};
</script>

<style lang="less" scoped>
.music {
  position: absolute;
  right: 0;
  top: 0;
  margin-right: 1rem;
  margin-top: 1rem;
  height: (6.125rem/2) /* 98/16 */;
  width: (5.5625rem/2) /* 89/16 */;
  z-index: 41;
  .note {
    height: (6.125rem/2) /* 98/16 */;
    width: (5.5625rem/2) /* 89/16 */;
    background-repeat: no-repeat;
    background-size: 100% auto;
  }
  .on {
    background-image: url("./img/kg_kg_00.png");
    background-repeat: no-repeat;
    height: (6.125rem/2) /* 98/16 */;
    width: (5.5625rem/2) /* 89/16 */;
    animation: musicRun 1s steps(1, end) infinite;
  }
  .off {
    background-image: url(./img/music-off.png);
  }
  .rotating {
    //animation: rotate-music 2s linear infinite;
  }
}

@keyframes musicRun {
  0% {
    background-image: url("./img/kg_kg_00.png");
  }
  4% {
    background-image: url("./img/kg_kg_01.png");
  }
  8% {
    background-image: url("./img/kg_kg_02.png");
  }
  12% {
    background-image: url("./img/kg_kg_03.png");
  }
  16% {
    background-image: url("./img/kg_kg_04.png");
  }
  20% {
    background-image: url("./img/kg_kg_05.png");
  }
  24% {
    background-image: url("./img/kg_kg_06.png");
  }
  28% {
    background-image: url("./img/kg_kg_07.png");
  }
  32% {
    background-image: url("./img/kg_kg_08.png");
  }
  36% {
    background-image: url("./img/kg_kg_09.png");
  }
  40% {
    background-image: url("./img/kg_kg_10.png");
  }
  44% {
    background-image: url("./img/kg_kg_11.png");
  }
  48% {
    background-image: url("./img/kg_kg_12.png");
  }
  52% {
    background-image: url("./img/kg_kg_13.png");
  }
  56% {
    background-image: url("./img/kg_kg_14.png");
  }
  60% {
    background-image: url("./img/kg_kg_15.png");
  }
  64% {
    background-image: url("./img/kg_kg_16.png");
  }
  68% {
    background-image: url("./img/kg_kg_17.png");
  }
  72% {
    background-image: url("./img/kg_kg_18.png");
  }
  76% {
    background-image: url("./img/kg_kg_19.png");
  }
  80% {
    background-image: url("./img/kg_kg_20.png");
  }
  84% {
    background-image: url("./img/kg_kg_21.png");
  }
  88% {
    background-image: url("./img/kg_kg_22.png");
  }
  92% {
    background-image: url("./img/kg_kg_23.png");
  }
  96% {
    background-image: url("./img/kg_kg_24.png");
  }
  100%{background-image: url("./img/kg_kg_00.png");}
}

@keyframes musicRun2 {
  0% {
    background-position: 0px 0;
  }
  4% {
    background-position: -(98px/2) 0;
  }
  8% {
    background-position: 0 -(89px/2);
  }
  12% {
    background-position: -(98px/2) -(89px/2);
  }
  16% {
    background-position: -(196px/2) 0;
  }
  20% {
    background-position: -(196px/2) -(89px/2);
  }
  24% {
    background-position: 0px -(178px/2);
  }
  28% {
    background-position: -(98px/2) -(178px/2);
  }
  32% {
    background-position: -(196px/2) -(178px/2);
  }
  36% {
    background-position: -(294px/2) 0;
  }
  40% {
    background-position: -(294px/2) -(89px/2);
  }
  44% {
    background-position: -(294px/2) -(178px/2);
  }
  48% {
    background-position: 0 -(267px/2);
  }
  52% {
    background-position: -(98px/2) -(267px/2);
  }
  56% {
    background-position: -(196px/2) -(267px/2);
  }
  60% {
    background-position: -(294px/2) -(267px/2);
  }
  64% {
    background-position: -(392px/2) 0;
  }
  68% {
    background-position: -(392px/2) -(89px/2);
  }
  72% {
    background-position: -(392px/2) -(178px/2);
  }
  76% {
    background-position: -(392px/2) -(267px/2);
  }
  80% {
    background-position: 0 -(356px/2);
  }
  84% {
    background-position: -(98px/2) -(356px/2);
  }
  88% {
    background-position: -(196px/2) -(356px/2);
  }
  92% {
    background-position: -(294px/2) -(356px/2);
  }
  96% {
    background-position: -(392px/2) -(356px/2);
  }
  100%{}
}
</style>



// WEBPACK FOOTER //
// src/components/musicplayer/music-player.vue